import { func, bool } from "prop-types";
import { connect } from "react-redux";

import { clearSecondaryFilter } from "../actions/creators";
import TextButton from "../../../../shared/v2/TextButton";

const mapDispatchToProps = (dispatch) => ({
  onClearSecondaryFilter: () => dispatch(clearSecondaryFilter()),
});

const Clearer = connect(
  (state) => ({ filtered: state.tdpTasksReducer.filtered }),
  mapDispatchToProps,
)(({ filtered, onClearSecondaryFilter, toggleDrawer }) => (
  <TextButton
    disabled={!filtered}
    onClick={() => {
      onClearSecondaryFilter();
      toggleDrawer(false);
    }}
  >
    CLEAR FILTER
  </TextButton>
));

Clearer.propTypes = {
  filtered: bool,
  onClearSecondaryFilter: func,
  toggleDrawer: func,
};

Clearer.defaultProps = {
  onClearSecondaryFilter: () => {},
  toggleDrawer: () => {},
};

export default Clearer;
